export class GameState {
    public alienIndex: number;
    public dialogIndex: number;
    public score: number;

    /**
     * Reference to the current game state at all times
     * Dynamically changes!
     */
    public static current: GameState;

    constructor() {
        this.alienIndex = 0;
        this.dialogIndex = 0;
        this.score = 0;
    }
}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/objects/GameState.ts